// Load stylesheet dynamically (non-blocking, async)
function loadStylesheetForSaleReviews(href) {
    const hrefKey = href.split('/').pop();
    if (document.querySelector(`link[href*="${hrefKey}"]`)) {
      return;
    }
    
    const loadStylesheetAsync = () => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.media = 'print';
      link.onload = function() {
        this.media = 'all';
      };
      link.onerror = () => {
        console.warn(`Failed to load stylesheet: ${href}`);
      };
      document.head.appendChild(link);
    };
  
    if (typeof window.requestIdleCallback !== 'undefined') {
      requestIdleCallback(loadStylesheetAsync, { timeout: 2000 });
    } else {
      setTimeout(loadStylesheetAsync, 0);
    }
  }
  
  if (!window.customElements.get('sale-reviews-swiper')) {
    customElements.define('sale-reviews-swiper', class extends HTMLElement {
      constructor() {
          super();
          this.swiper = null;
          this.$section = null;
      }
  
      connectedCallback() {
          this.$section = $(this);
          
          // Check if progressbar pagination is enabled via dataset
          const isProgressbar = this.dataset.paginationProgressbar === 'true';
          
          // Load progressbar stylesheet if needed
          if (isProgressbar) {
            const existingScript = document.querySelector('script[src*="sale-reviews-swiper.js"]');
            let assetBaseUrl = '/assets/';
            if (existingScript && existingScript.src) {
              const match = existingScript.src.match(/^(.*\/)assets\//);
              if (match) {
                assetBaseUrl = match[1] + 'assets/';
              }
            }
            loadStylesheetForSaleReviews(assetBaseUrl + 'swiper-progressbar.css');
          }
          
          // Initialize Swiper - Optimized for reviews carousel
          const paginationEl = this.$section.find(".swiper-pagination")[0];
          this.swiper = new Swiper(this.$section.find(".swiper-container")[0], {
              centeredSlides: true,
              loop: true,
              pagination: {
                  el: paginationEl,
                  clickable: true,
                  type: isProgressbar ? 'progressbar' : 'bullets'
              },
              navigation: {
                  nextEl: this.$section.find(".swiper-button-next")[0],
                  prevEl: this.$section.find(".swiper-button-prev")[0]
              },
              breakpoints: {
                  0: {
                      slidesPerView: 1,
                      spaceBetween: 10,
                  },
                  768: {
                      slidesPerView: 1,
                      spaceBetween: 10,
                  },
                  1024: {
                      slidesPerView: 4,
                      spaceBetween: 20,
                      centeredSlides: false
                  }
              }
          });
  
          // Left/Right button controls
          this.$section.find(".swiper-button-prev").on("click", () => {
              if (this.swiper) this.swiper.slidePrev();
          });
  
          this.$section.find(".swiper-button-next").on("click", () => {
              if (this.swiper) this.swiper.slideNext();
          });
  
          // Slide change event
          this.swiper.on("slideChange", () => {
              // Can add reviews carousel specific logic here
          });
  
          // Autoplay progress bar
          this.swiper.on("autoplayTimeLeft", (swiper, time, progress) => {
              const pagination = this.$section.find(".swiper-pagination")[0];
              if (pagination) {
                  pagination.style.setProperty("--swiper-progress", `${(1 - progress) * 100}%`);
              }
          });
  
          // Window resize event
          this.resizeHandler = () => {
              if (this.swiper) {
                  this.swiper.update();
              }
          };
          
          window.addEventListener("resize", this.resizeHandler);
      }
  
      disconnectedCallback() {
          if (this.swiper) {
              this.swiper.destroy(true, true);
          }
          window.removeEventListener("resize", this.resizeHandler);
      }
    });
  }
  